import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { oauthCallback } from '@/services/sheets'
import { useGoogleConnection } from '@/store/appStore'

const OAuthCallback = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState<'loading' | 'error'>('loading')
  const { setGoogleConnected, setGoogleExpiry } = useGoogleConnection()

  useEffect(() => {
    const handleAuth = async () => {
      const code = searchParams.get('code')

      if (!code) {
        setStatus('error')
        console.error('No code found')
        return
      }

      try {
        await oauthCallback(code)
        setGoogleConnected(true)
        setGoogleExpiry(Date.now() + 3600000) // 1 hour
        navigate('/dashboard')
      } catch (error) {
        console.error('OAuth callback failed:', error)
        setStatus('error')
      }
    }

    handleAuth()
    // this prevents infinite re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white border border-blue-400 rounded-2xl p-8 w-full max-w-md text-center shadow-md">
        {status === 'loading' || status !== 'error' ? (
          <>
            <p className="text-lg font-semibold text-gray-900 mb-2">Connecting to Google Sheets…</p>
            <p className="text-sm text-gray-500">Please wait while we finalize authentication.</p>
          </>
        ) : (
          <>
            <p className="text-lg font-semibold text-red-600 mb-2">Something went wrong</p>
            <p className="text-sm text-gray-500">
              We couldn't complete the connection. Please try again.
            </p>
            <p className="text-sm text-gray-500 mt-2 cursor-pointer">
              <button
                onClick={() => navigate('/dashboard')}
                className="btn cursor-pointer text-blue-600"
              >
                Back to Dashboard
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default OAuthCallback
